import type { AdvisoryAiReportDetail, AdvisoryAiOrgReportRow } from '@/features/advisory-ai/types'
import type { CallStatus } from '../calls/utils'

/** Minimal row for reusing the per-call status helpers (getCallStatus/getStepProgress) on a report. */
export function reportStatusRow(report?: AdvisoryAiReportDetail | null): AdvisoryAiOrgReportRow {
  return {
    advisoryCallId: report?.advisoryCallId ?? '',
    reports: report?.reports ?? [],
    startDate: report?.startDate ?? null,
    endDate: report?.endDate ?? null,
    meetingDate: report?.meetingDate ?? null,
    createdAt: report?.createdAt ?? null,
    status: String(report?.status ?? 'PENDING'),
    exportType: report?.exportType ?? null,
    canInteract: true,
  }
}

export const GROUP_STATUS_META: Record<
  CallStatus,
  { title: string; dotColor: string; borderColor: string; tagColor: string; progressColor: string }
> = {
  needsAttention: {
    title: 'NEEDS ATTENTION',
    dotColor: 'bg-red-500',
    borderColor: 'border-l-red-500',
    tagColor: 'bg-red-50 text-red-700 border-red-200',
    progressColor: '#ef4444',
  },
  inProgress: {
    title: 'IN PROGRESS',
    dotColor: 'bg-orange-500',
    borderColor: 'border-l-orange-500',
    tagColor: 'bg-orange-50 text-orange-700 border-orange-200',
    progressColor: '#f97316',
  },
  // Blue, matching the "Generating" pill on the export cards.
  generating: {
    title: 'GENERATING OUTPUTS',
    dotColor: 'bg-blue-500',
    borderColor: 'border-l-blue-500',
    tagColor: 'bg-blue-50 text-blue-700 border-blue-200',
    progressColor: '#3b82f6',
  },
  ready: {
    title: 'READY TO GO',
    dotColor: 'bg-green-500',
    borderColor: 'border-l-green-500',
    tagColor: 'bg-green-50 text-green-700 border-green-200',
    progressColor: '#22c55e',
  },
}
